import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

export const MaskedLines = ({ lines = [], className = "", lineClassName = "", delay = 0.2, as: Tag = "span" }) => (
  <Tag className={className}>
    {lines.map((line, i) => (
      <span key={i} className="block overflow-hidden pb-[0.1em] -mb-[0.1em]">
        <motion.span
          className={`block ${lineClassName}`}
          initial={{ y: "115%" }}
          animate={{ y: 0 }}
          transition={{ duration: 1, delay: delay + i * 0.13, ease: EASE }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </Tag>
);

export const Reveal = ({ children, delay = 0, y = 36, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.9, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const Overline = ({ children, className = "" }) => (
  <span
    className={`inline-flex items-center gap-3 text-xs uppercase tracking-[0.25em] text-white/50 font-medium ${className}`}
  >
    <span className="w-8 h-px bg-gradient-to-r from-brand-blue to-brand-purple" />
    {children}
  </span>
);

export { EASE };
